import { Pipe, PipeTransform, inject } from '@angular/core';

import { LocaleService } from './locale.service';
import type { TranslationParams } from './locale.model';

@Pipe({
  name: 't',
  standalone: true,
  pure: false,
})
export class TranslatePipe implements PipeTransform {
  private readonly locale = inject(LocaleService);

  transform(key: string, params?: TranslationParams): string {
    this.locale.locale();
    return this.locale.t(key, params);
  }
}
